import { ISystemInformation } from './../../interfaces/ISystemInformation';
import { useRequest } from './../providers/useRequest';
import AppError from '../../errors/AppError';
import IUseTimeClocking from '../../interfaces/IUseTimeClocking';
import { ITenantConfig } from '../../interfaces/ITenantConfig';

const useSystemInformationService = () => {
  const request = useRequest<ISystemInformation>();
  const useTimeClockingRequest = useRequest<IUseTimeClocking>();
  const useTenantConfigRequest = useRequest<ITenantConfig>();
  const path = 'system-info';

  const getSystemInformation = async (): Promise<ISystemInformation> => {
    return await request
      .getOne({ path: `${path}/version`, sendAuthorization: true })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const getUseTimeClockingTenant = async (tenant: string): Promise<IUseTimeClocking> => {
    return await useTimeClockingRequest
      .getOne({
        path: `${path}/list-use-time-clocking/${tenant}`,
        sendAuthorization: false,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  const listTenantConfig = async (tenant: string): Promise<ITenantConfig> => {
    return await useTenantConfigRequest
      .post({
        path: `${path}/tenant-config`,
        body: {
          tenantDomain: tenant,
        },
        sendAuthorization: false,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  return { getSystemInformation, getUseTimeClockingTenant, listTenantConfig };
};

export { useSystemInformationService };
